import React from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
import { JoinPlatformButton } from './JoinPlatformButton';
import { partnerFormUrl } from '../data/appTour';
import { Sparkles } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-206" data-mp="9ipcvdlvdi16">
      {/* Full-width background image */}
      <div className="absolute inset-0" data-id="element-207" data-mp="12a0j75mcfqrz">
        <img src="https://cdn.magicpatterns.com/uploads/dZ8Roj232HgCNMNue9AsoW/pexels-anntarazevich-4926666.jpg" alt="Women supporting each other" className="w-full h-full object-cover object-[center_30%] scale-110" data-id="element-208" data-mp="128pjbgw0r365" />
        {/* Subtle overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal/40 via-charcoal/30 to-charcoal/50" data-id="element-209" data-mp="neaw145f97lo"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-purple-900/20 to-transparent" data-id="element-210" data-mp="3cz5v8bjvq00c"></div>
      </div>

      <div className="max-w-6xl mx-auto px-6 relative z-10 text-center text-white" data-id="element-211" data-mp="3j8iw0w4jiat4">
        <FadeIn delay={100} data-id="element-212" data-mp="3j6ocnm8x2qr5">
          <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full border border-white/30 bg-white/10 backdrop-blur-md mb-8" data-id="element-213" data-mp="3o85bzdbr655m">
            <Sparkles className="w-4 h-4 text-purple-300" data-id="element-214" data-mp="399thndbur8hm" />
            <span className="text-sm font-medium tracking-wide uppercase text-white/90" data-id="element-215" data-mp="3e8whmjcz6oiq">
              A New Standard in Women's Wellness
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={300} data-id="element-216" data-mp="358howyxom757">
          <h1 className="text-5xl md:text-6xl lg:text-8xl font-serif text-white leading-[1.1] mb-8 tracking-tight max-w-5xl mx-auto drop-shadow-2xl" data-id="element-217" data-mp="359j9pv4i2804">
            The Future of Women's Wellness,{' '}
            <span className="italic text-white/95" data-id="element-218" data-mp="2vjpywwc6lwwx">Curated Intelligently</span>
          </h1>
        </FadeIn>

        <FadeIn delay={500} data-id="element-219" data-mp="2hjoytj3qqtii">
          <p className="text-lg md:text-2xl text-white/90 max-w-3xl mx-auto mb-12 font-light leading-relaxed drop-shadow-lg" data-id="element-220" data-mp="2hlj8g19kaz7a">
            A private digital ecosystem connecting women to trusted
            practitioners, personalized care, and intelligent wellness pathways
            — all in one seamless platform.
          </p>
        </FadeIn>

        <FadeIn delay={700} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-221" data-mp="id9v0gzmuhve">
          <JoinPlatformButton className="w-full sm:w-auto bg-purple-200 text-gray-700 hover:bg-purple-300 shadow-xl font-sans font-black" data-id="element-222" data-mp="deyitzlv7va0" />
          <a href={partnerFormUrl} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-223" data-mp="1622kbulr1rh1">
            <Button variant="outline" size="lg" className="w-full sm:w-auto border-2 border-white text-white hover:bg-white/20 backdrop-blur-sm bg-white/10 shadow-xl" data-id="element-224" data-mp="114suweyd1ft7">
              Partner With Us
            </Button>
          </a>
        </FadeIn>
      </div>
    </section>;
}